import { render } from "./live.vue?vue&type=template&id=26f36e6a&scoped=true"
import script from "./live.vue?vue&type=script&lang=js"
export * from "./live.vue?vue&type=script&lang=js"

import "./live.vue?vue&type=style&index=0&id=26f36e6a&scoped=true&lang=css"

import exportComponent from "/root/workspace/adx-frontend_wteR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f36e6a"]])

export default __exports__